export default __webpack_public_path__ + "static/media/close_button.0316efba.svg";